'use strict';

const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ_SPEEDTECH: {
				name: ['(客製)薪資', '(客製)薪資', '(客製)Payroll'],
				children: {
					ZZ_SPEEDTECH_PB10410: {
						name: ['(客製)輪班津貼計算', '(客製)輪班津貼計算', '(客製)Section Allowance Calculation'],
						url: '/zz_speedtech_pb10410',
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};
